<template>
  <div class="ev-stoplist" v-if="hasStops">
    <!-- Tabela stopova -->
    <div class="ev-table-section">
      <div class="ev-table-header">
        <h3 class="ev-table-title">
          <span class="ev-table-icon">📍</span>
          Stopovi
          <span v-if="params.data.length > 1" class="ev-table-count">
            {{ params.data.length - 1 }}
          </span>
        </h3>
      </div>
      <div class="ev-table-container">
        <vue-table-dynamic
          :params="params"
          @cell-contextmenu="cm"
          @cell-click="tableCellClicked"
        ></vue-table-dynamic>
      </div>
    </div>

    <!-- Mapa -->
    <div class="ev-card ev-stoplist-map-card">
      <h3 class="ev-section-title">
        <span class="ev-section-icon">🗺️</span>
        Mapa
      </h3>
      <div class="ev-stoplist-map-container">
        <l-map style="height: 500px" :zoom="map.zoom" :center="map.center">
          <l-tile-layer
            :url="map.url"
            :attribution="map.attribution"
          ></l-tile-layer>
          <div>
            <l-marker
              v-for="(item, index) in markers"
              :key="'marker-' + index"
              :lat-lng="item.location"
              :ref="`marker-${item.index}`"
              @ready="ready"
              ><l-popup :options="{ autoClose: false }">{{
                item.text
              }}</l-popup></l-marker
            >
          </div>
        </l-map>
      </div>
    </div>

    <!-- Context Menu -->
    <context-menu-max :display="showContextMenu" ref="menu">
      <ul class="ev-context-menu-list">
        <li
          v-show="showContextMenuDeactivate"
          @click="addRemoteClicked(1)"
          class="ev-context-menu-item ev-context-menu-item--success"
        >
          <span class="ev-context-icon">▶️</span>
          Dodaj kao početak
        </li>
        <li
          class="ev-context-menu-divider"
          v-show="showContextMenuDeactivate"
        ></li>
        <li
          v-show="showContextMenuDeactivate"
          @click="addRemoteClicked(2)"
          class="ev-context-menu-item ev-context-menu-item--danger"
        >
          <span class="ev-context-icon">⏹️</span>
          Dodaj kao kraj
        </li>
      </ul>
      <div v-if="selectedTime" class="ev-context-menu-footer">
        <span class="ev-context-menu-time">⏰ {{ formatSelectedTime }}</span>
      </div>
    </context-menu-max>
  </div>
</template>

<script>
import reportService from "../../services/report.service";
// import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
const { DateTime } = require("luxon");
const TIMEZONE_OFFSET = 0; // SUMMER = 2, WINTER = 1

import ContextMenuMax from "../parts/ContextMenu.vue";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "StopList",

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    ContextMenuMax,
  },

  props: {
    today: Date,
    tomorrow: Date,
    employee: Object,
  },

  data() {
    return {
      showContextMenuDeactivate: true,
      showContextMenu: false,
      selectedTime: null,
      selectedLat: 0,
      selectedLng: 0,
      map: {
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        zoom: 13,
        center: [42.775058, 18.947913],
      },
      markers: [],
      jaglika: "paja",
      params: {
        data: [
          [
            "Index",
            "Početak stopa",
            "Kraj stopa",
            "Trajanje",
            "Mjesto",
            "Motor uključen",
            "Potrošnja",
          ],
        ],
        header: "row",
        border: true,
        stripe: true,
        pagination: false,
      },
    };
  },

  mounted() {
    this.createdOrUpdated();
  },

  computed: {
    hasStops() {
      return this.params.data.length > 1;
    },
    formatSelectedTime() {
      if (!this.selectedTime) return "";
      return this.selectedTime.toLocaleTimeString("sr-latn-cs");
    },
  },

  methods: {
    addRemoteClicked(action) {
      console.log(this.employee.id);
      console.log(action);
      var luxonStartDate = DateTime.fromJSDate(this.selectedTime);
      let lsd = luxonStartDate.toISO().split("+")[0];
      console.log(lsd);
      this.callReport(action, lsd);
    },

    callReport(action, lsd) {
      reportService
        .CreateNewAccessRemote({
          AccessTime: lsd,
          CompanyId: this.$store.state.general.companyId, //TODO: MAKE DYNAMIC
          EmployeeId: this.employee.id,
          EventId: action,
          ChoiceId: action === 2 ? 904 : null, // action = 2 - pauza
          Note: "remote",
          Latitude: this.selectedLat,
          Longitude: this.selectedLng,
          Value1: null,
          String1: null,
        })
        .then((response) => {
          console.log(response);
          this.$emit("accessRemoteCreated", response);
        });
    },

    cm(params, row, column) {
      // console.log(params);
      // console.log(row);
      // console.log(column);
      console.log(this.params.data[row][column]);

      // calculate selected time
      let theTime = this.params.data[row][column];

      this.selectedLat = this.markers[row - 1].location[0];
      this.selectedLng = this.markers[row - 1].location[1];

      // console.log("lat lng");
      // console.log(this.markers);
      // console.log(this.selectedLat);
      // console.log(this.selectedLng);

      let theToday = new Date(
        this.today.getTime() - this.today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];

      console.log(this.today);
      console.log(theToday);
      console.log(theTime);
      this.selectedTime = new Date(theToday + "T" + theTime);
      console.log(this.selectedTime);
      this.openContextMenu(params);
    },

    openContextMenu(e) {
      this.$refs.menu.open(e);
    },

    cmSendAllToNonWorkingDay() {},

    cmSendToNonWorkingDay() {},

    ready(what) {
      console.log("the marker is ready");
      console.log(what);
      what.openPopup();
    },

    tableCellClicked(clmn, row) {
      console.log(clmn, row);
      console.log("pssy");
      console.log(this.markers[clmn - 1].index);
      console.log(this.markers[clmn - 1].location);
      this.map.center = this.markers[clmn - 1].location;
      this.map.zoom = 16;
    },

    createdOrUpdated() {
      console.log("jure");
      this.params.data = [
        [
          "Index",
          "Početak stopa",
          "Kraj stopa",
          "Trajanje",
          "Mjesto",
          "Motor uključen",
          "Potrošnja",
        ],
      ];
      reportService
        .GetImeiListByEmployeeId(this.employee.id)
        .then((response) => {
          console.log(response.data);

          if (response.data.length != 0) {
            let imei = response.data[0].imei;
            console.log("mačak stoša");
            console.log(this.today);
            console.log(this.tomorrow);

            let theToday = new Date(
              this.today.getTime() - this.today.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T")[0];
            let theTomorrow = new Date(
              this.tomorrow.getTime() -
                this.tomorrow.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T")[0];

            console.log(theToday);
            console.log(theTomorrow);

            reportService
              .GetGpsStopListByImeiAndStartDateAndEndDate(
                imei,
                theToday,
                theTomorrow
              )
              .then((response) => {
                console.log("Ć");
                console.log(response.data);
                let ndx = 0;
                // ubacimo stopove
                response.data.forEach((stop) => {
                  let theStart = new Date(stop.stopTimeStart);
                  let theEnd = new Date(stop.stopTimeEnd);

                  // correct by 2 hours TODO HARDCODED
                  theStart.setHours(theStart.getHours() + TIMEZONE_OFFSET);
                  theEnd.setHours(theEnd.getHours() + TIMEZONE_OFFSET);

                  this.params.data.push([
                    ++ndx,
                    theStart.toLocaleTimeString("sr-latn-cs"),
                    theEnd.toLocaleTimeString("sr-latn-cs"),
                    stop.stopTimeSum,
                    stop.lat + ", " + stop.lng,
                    stop.engine_idle,
                    stop.fuel_consumption,
                  ]);

                  // form markers for the map view...
                  this.markers.push({
                    index: ndx,
                    location: [stop.lat, stop.lng],
                    text:
                      "(" +
                      ndx +
                      ") od " +
                      theStart.toLocaleTimeString("sr-latn-cs") +
                      " do " +
                      theEnd.toLocaleTimeString("sr-latn-cs") +
                      " - " +
                      stop.duration,
                  });

                  // center the map
                  this.map.center = [stop.lat, stop.lng];
                });

                console.log("hic");
                console.log(this.$refs);
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.ev-stoplist {
  margin-bottom: var(--ev-spacing-lg);
}

.ev-stoplist-map-card {
  margin-top: var(--ev-spacing-lg);
}

.ev-stoplist-map-container {
  border-radius: var(--ev-radius-lg);
  overflow: hidden;
  border: 2px solid var(--ev-border);
}

/* Context menu footer with selected time */
.ev-context-menu-footer {
  padding: 8px 16px;
  border-top: 1px solid var(--ev-border);
  background: var(--ev-bg);
}

.ev-context-menu-time {
  font-size: 12px;
  font-weight: 600;
  color: var(--ev-text-muted);
}
</style>